import axios from 'axios';
import { authStore } from '../features/Auth';

export const setupAuthInterceptor = () => {
	axios.interceptors.request.use(
		(config) => {
			return config;
		},
		(error) => Promise.reject(error),
	);

	axios.interceptors.response.use(
		async (response) => {
			const {
				status,
				data: { message },
			} = response || {};
			if (status === 401 && message === 'Session expired') {
				authStore.logout();
				return Promise.reject();
			}
			return response;
		},
		async (error) => {
			const originalRequest = error?.config;
			if (error?.response?.status === 401 && !originalRequest._retry) {
				console.log('Token expired or invalid, attempting refresh...');
			}
			return Promise.reject(error);
		},
	);
};
